import type { LoaderFunctionArgs } from 'react-router-dom';

import { userInfoQueryDefinition } from '@/entities/user-info';
import { userPhrQueryDefinition } from '@/entities/user-phr';
import { patientPrescriptionsQueryDefinition } from '@/entities/rx';

import { queryClient } from '@/app/providers/queryClient';

export async function patientWorkspaceLoader({ params }: LoaderFunctionArgs): Promise<null> {
  const userId = params.userId;
  if (typeof userId !== 'string' || userId.trim() === '') {
    throw new Response('Missing userId', { status: 400 });
  }

  const patientInfoQuery = userInfoQueryDefinition(userId);
  const patientInfoPromise = queryClient.ensureQueryData({
    ...patientInfoQuery,
    meta: {
      ...patientInfoQuery.meta,
      toastOnError: false,
    },
  });

  const phrQuery = userPhrQueryDefinition(userId);
  const phrPromise = queryClient.ensureQueryData({
    ...phrQuery,
    meta: {
      ...phrQuery.meta,
      toastOnError: false,
    },
  });

  const prescriptionsQuery = patientPrescriptionsQueryDefinition(userId, { synchronize: true });
  const prescriptionsPromise = queryClient.prefetchQuery({
    ...prescriptionsQuery,
    meta: {
      ...prescriptionsQuery.meta,
      toastOnError: false,
    },
  });

  await Promise.all([patientInfoPromise, phrPromise, prescriptionsPromise]);
  return null;
}
